function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import YoutubeVideoWithPosterComponent from "components/core/youtube-video-with-poster/youtube-video-with-poster-component";
import YoutubeVideoModalComponent from "components/core/youtube-video-modal/youtube-video-modal-component";
import { YOUTUBE_MODAL_OPEN, YOUTUBE_MODAL_CLOSE } from "/constants/bigbrain-event-types";
import { AUTO } from "/constants/cloudinary-asset-qualities";
import AssetComponent from "/components/core/asset/asset-component";
import classnames from "classnames";
import { StyledYoutubeVideoAssetComponent } from "./youtube-video-asset-component.scss";
const DEFAULT_WIDTH_PRECENTAGE = 100;
const VIDEO = "video";
const IMAGE = "image";
class YoutubeVideoAssetComponent extends PureComponent {
    componentDidMount() {
        const { videoId } = this.props;
        BigBrain("track", YOUTUBE_MODAL_OPEN, {
            kind: videoId
        });
        this.setState({
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth
        });
    }
    onPlayButtonClicked() {
        const { videoId } = this.props;
        BigBrain("track", YOUTUBE_MODAL_OPEN, {
            kind: videoId
        });
        this.setState({
            windowHeight: window.innerHeight - 100,
            windowWidth: window.innerWidth - 100
        }, ()=>this.setState({
                openModal: true
            }));
    }
    closeModal() {
        const { videoId } = this.props;
        BigBrain("track", YOUTUBE_MODAL_CLOSE, {
            kind: videoId
        });
        this.setState({
            openModal: false
        });
    }
    render() {
        const { openModal, windowHeight, windowWidth, previewWidth } = this.state;
        const { videoId, backgroundImg, isMobileOrTabletBrowser, mobileWidth, width, alt, fullWidth } = this.props;
        const finalWidth = isMobileOrTabletBrowser && mobileWidth ? mobileWidth : width;
        const widthInPercentage = finalWidth ? `${finalWidth}%` : "100%";
        return /*#__PURE__*/ _jsxs(StyledYoutubeVideoAssetComponent, {
            className: classnames("youtube-video-asset-component", {
                "full-width": fullWidth
            }),
            children: [
                /*#__PURE__*/ _jsx(YoutubeVideoModalComponent, {
                    videoId: videoId,
                    minHeight: 546,
                    isOpen: openModal,
                    opts: {
                        width: windowWidth,
                        height: windowHeight,
                        playerVars: {
                            autoplay: true,
                            rel: 0,
                            showinfo: 0
                        }
                    },
                    onCloseModal: this.closeModal,
                    withSignup: false
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "video-part",
                    style: {
                        width: widthInPercentage
                    },
                    children: isMobileOrTabletBrowser ? /*#__PURE__*/ _jsx("div", {
                        className: "video-component-wrapper",
                        children: /*#__PURE__*/ _jsx(YoutubeVideoWithPosterComponent, {
                            videoId: videoId,
                            poster: backgroundImg,
                            alt: alt,
                            muted: false,
                            volume: 100,
                            previewRenderer: this.previewRenderer,
                            fitToParent: true,
                            videoOpts: {
                                playerVars: {
                                    autoplay: true,
                                    rel: 0,
                                    showinfo: 0
                                }
                            }
                        })
                    }) : this.renderDesktopPreview()
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "renderPlayButton", ()=>{
            return /*#__PURE__*/ _jsx("button", {
                className: "play-button-container",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "play-button"
                })
            });
        });
        _define_property(this, "getPreviewAsset", ()=>{
            const { backgroundImg, videoPlaceholder, alt } = this.props;
            if (videoPlaceholder) {
                return {
                    [VIDEO]: {
                        src: videoPlaceholder,
                        loop: true,
                        ariaLabel: alt
                    }
                };
            } else {
                return {
                    [IMAGE]: {
                        src: backgroundImg,
                        pictureClass: "poster-image",
                        alt: alt
                    }
                };
            }
        });
        _define_property(this, "renderDesktopPreview", ()=>{
            return /*#__PURE__*/ _jsx("div", {
                className: "poster-image-wrapper",
                children: this.previewRenderer(this.onPlayButtonClicked)
            });
        });
        _define_property(this, "previewRenderer", (onClick)=>{
            const { assetQuality } = this.props;
            const asset = this.getPreviewAsset();
            return /*#__PURE__*/ _jsxs("div", {
                onClick: onClick,
                children: [
                    /*#__PURE__*/ _jsx(AssetComponent, _object_spread_props(_object_spread({}, asset), {
                        assetQuality: assetQuality
                    })),
                    this.renderPlayButton()
                ]
            });
        });
        this.state = {
            openModal: false,
            windowWidth: 780,
            windowHeight: 928
        };
        this.onPlayButtonClicked = this.onPlayButtonClicked.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
}
export { YoutubeVideoAssetComponent as default };
YoutubeVideoAssetComponent.defaultProps = {
    backgroundImg: "/static/img/tags/video_image.png",
    videoId: "l-7awVpecvU",
    width: DEFAULT_WIDTH_PRECENTAGE,
    mobileWidth: DEFAULT_WIDTH_PRECENTAGE,
    assetQuality: AUTO
};
